import styled from 'styled-components'
import { Button } from 'antd'

export const CompleteButton = styled(Button)`
    && {
        width: 200px;
        display: flex;
        justify-content: center;
        justify-self: flex-end;
        background-color: #7BAD7E;
        border-color: #7BAD7E;
    }
`
